import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Feature, SiteService } from '../services/site.service';

/** LJISE-896: gates a route behind a feature this site has (GET /api/config/site) — the API
 *  answers 404 for a switched-off feature anyway, this keeps users off a page that can't work. */
export function featureGuard(feature: Feature): CanActivateFn {
  return () =>
    inject(SiteService).enabled(feature) ? true : inject(Router).parseUrl('/dashboard');
}
